<template>
    <div class="search-label-cnt">
        <h1 class="s-h1">{{extraterm}}</h1>
    </div>

    <BaseThemeSearchNavigation />
</template>

<script setup>
	const props = defineProps(['extraterm']);
</script>